import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/packagesSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const PrimaryCategory = () => {
  const dispatch = useDispatch();
  const primaryCategoriesLoading = useSelector(
    (state) => state.packagesSales.primaryCategoriesLoading
  );
  const primaryCategories = useSelector((state) => state.packagesSales.filters.primary_categories);
  const selectedPrimaryCategories = useSelector(
    (state) => state.packagesSales.selectedFilters.primary_categories
  );

  return primaryCategoriesLoading ? (
    <LoadingAnimation uiLoader />
  ) : (
    <MultiSelectDropdown
      options={primaryCategories}
      selectedFilters={selectedPrimaryCategories}
      placeholder="Primary Categories"
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      height={324}
      onSelectChange={(data) => dispatch(actionCreators.updatePrimaryCategory(data))}
    />
  );
};

export default PrimaryCategory;
